








































































































import {Component, Prop} from 'vue-property-decorator';
import Form, {Send} from '@/components/form-base';
import {CardForm, DialogForm, FormOverlay} from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import NoFoundCombobox from '@/components/no-found-combobox.vue';
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import CustomConversionsApi from '@/services/rest/bemob/custom-conversions';
import ReportAPI from '@/services/rest/bemob/report';
import _ from 'lodash';

const md5 = require('md5');


@Component({
  components: {
    Template,
    FormOverlay,
    DialogForm,
    CardForm,
    ErrorAggregator,
    HeaderButtons,
    NoFoundCombobox
  }
})
export default class CreateCustomConversions extends Form {
  @Prop({ default: {} })
  data: object;

  customConversionsApi: CustomConversionsApi = new CustomConversionsApi();
  reportApi: ReportAPI = new ReportAPI();

  loading: boolean = false;

  form: any = this.getDefaultForm();

  errors: any[] = [];
  search: string = '';

  errorsControlActive: boolean = false;

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  getDefaultForm() {
    return {
      name: '',
      values: [],
      id:'',
      includeInConversions: false,
      includeInCost: false,
      sendPostback: false,
      includeInRevenue: false,
      includeInDailyCap: false
    }as {
      name: string,
      values: any,
      id:string,
      includeInConversions: boolean,
      includeInCost: boolean,
      sendPostback: boolean,
      includeInRevenue: boolean,
      includeInDailyCap: boolean
    };
  }

  mounted() {
    this.$on('error', (e: any) => {
      this.$store.commit('loading', false);

      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    this.form = _.isEmpty(this.data) ? this.getDefaultForm() : { ...this.data }
    this.oldHash = this.getCurrentHash()
  }

  sendPostbacksChanged() {
    if(!this.form.sendPostback){
      this.form.includeInCost = false;
    }
  }

  @Send(true)
  save() {
    this.loading = true;

    this.$store.commit('loading', true);
    const method = this.form.id ? 'put' : 'post';

    return this.customConversionsApi[method](this.form).then(()=>{
      this.customConversionsApi.get().then((data:any)=>this.$store.commit('tableCustomEvents', data));
      this.reportApi.getSupportedMetrics()
      this.close();

      this.$mixpanel?.track(this.form.id ? 'custom_event_edit':'custom_event_create', {
        'name': this.form.name,
        'values': this.form.values
      });
    })
    .catch((error) => {
      this.$store.commit('loading', false);
      this.loading = false;

      return Promise.reject(error);
    })
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
    this.$store.commit('loading', false);
  }

}
